import React from 'react'
import style from '../startedsoon/startsoon.module.css'

function AgastyabySunny() {
  return (
    <div className = {style.start_soon}>
        <img src='https://edge.uacdn.net/static/thumbnail/course/839810a20ab6455db8dfe774c7ca02d7.jpg?q=75&w=1000&fm=webp' alt='_Sumit_img'/>
        <div>
          <p>ENGLISH   GENERAL AWARENESS</p>
          <h4>Agastya: Complete Course on Geography for NDA 1 2022</h4> 
          <p>Lesson 22 • Mar 13, 2022 5:30 PM</p> 
          <p>Sunny Verma</p> 
        </div>
    </div>        
  )
}
export default AgastyabySunny;